/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   getNameString helper for locales
 */

import type { selectLocaleGuideLocale } from '../selectors'

const N_A_MESSAGE = 'N/A'

export const getNameString = (locale?: ReturnType<typeof selectLocaleGuideLocale>) => {
  if (!locale) {
    return N_A_MESSAGE
  }
  const { city, name, state } = locale

  if (name && state) {
    if (city) {
      return `${name}, ${city}${state ? `, ${state}` : ''}`
    } else {
      return `${name}${state ? `, ${state}` : ''}`
    }
  } else {
    return N_A_MESSAGE
  }
}
